"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _HorizontalMerchCard = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/HorizontalMerchCard"));

var _CmsMarketingBundlePriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/CmsMarketingBundlePriceDisplay"));

var _CmsMarketingBundleBizObjectives = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/CmsMarketingBundleBizObjectives"));

var _CmsMarketingBundleFloatingAlert = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/CmsMarketingBundleFloatingAlert"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _ProductsAndPlansNavIds = require("pricing-pages-unified-ui/constants/ProductsAndPlansNavIds");

var _NonMerchandiseIdIdentifers = require("pricing-pages-unified-ui/constants/NonMerchandiseIdIdentifers");

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _CMSStarterBundleSelectors = require("pricing-pages-unified-ui/selectors/CMSStarterBundleSelectors");

var _CodeSplitEnvWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/CodeSplitEnvWrapper"));

var _ExperimentTreatmentSelectors = require("../../selectors/ExperimentTreatmentSelectors");

var _MarketingContactsSelectors = require("pricing-pages-unified-ui/selectors/MarketingContactsSelectors");

var CmsMarketingBundleHorizontalMerchCard = function CmsMarketingBundleHorizontalMerchCard(_ref) {
  var dontShowCMSStarterBundle = _ref.dontShowCMSStarterBundle,
      hasPricingAndPurchasingSucceeded = _ref.hasPricingAndPurchasingSucceeded;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      cmsMarketingCardRef = _useState2[0],
      setCmsMarketingCardRef = _useState2[1];

  var onCmsMarketingCardRefSet = (0, _react.useCallback)(function (el) {
    return setCmsMarketingCardRef(el);
  });
  var mon332Param = (0, _reactRedux.useSelector)(_ExperimentTreatmentSelectors.mon332ParamSelector);
  var mon332ShowPopup = mon332Param !== 'false';
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);

  if (dontShowCMSStarterBundle) {
    return null;
  }

  return _react.default.createElement(_react.default.Fragment, null, mon332ShowPopup && _react.default.createElement(_CmsMarketingBundleFloatingAlert.default, {
    targetElement: cmsMarketingCardRef,
    mon332Param: mon332Param
  }), _react.default.createElement("div", {
    ref: onCmsMarketingCardRefSet
  }, _react.default.createElement(_HorizontalMerchCard.default, {
    productIdentifier: isInMCBeta ? _NonMerchandiseIdIdentifers.CMS_STARTER_MC_BUNDLE : _NonMerchandiseIdIdentifers.CMS_STARTER_BUNDLE,
    ProductTitle: _react.default.createElement(_FormattedMessage.default, {
      message: "cmsHubMarketingStarterBundle.title"
    }),
    ProductDescription: _react.default.createElement(_FormattedMessage.default, {
      message: 'cmsHubMarketingStarterBundle.description'
    }),
    PriceDisplay: _react.default.createElement(_CmsMarketingBundlePriceDisplay.default, null),
    CTAs: _react.default.createElement(_CodeSplitEnvWrapper.default, {
      authedComponentLoader: function authedComponentLoader() {
        return import(
        /* webpackChunkName: "authed-chunk" */
        "pricing-pages-unified-ui/components/product-pages/CmsStarterBundlePrimaryCta");
      },
      publicComponentLoader: function publicComponentLoader() {
        return import(
        /* webpackChunkName: "public-chunk" */
        "pricing-pages-unified-ui/components/public-only/CmsStarterBundlePublicCta");
      }
    }),
    BizObjectives: _react.default.createElement(_CmsMarketingBundleBizObjectives.default, {
      hub: _ProductsAndPlansNavIds.MARKETING
    }),
    hasPricingAndPurchasingSucceeded: hasPricingAndPurchasingSucceeded
  })));
};

CmsMarketingBundleHorizontalMerchCard.propTypes = {
  dontShowCMSStarterBundle: _propTypes.default.bool.isRequired,
  hasPricingAndPurchasingSucceeded: _propTypes.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    dontShowCMSStarterBundle: (0, _CMSStarterBundleSelectors.dontShowCMSStarterBundleSelector)(state),
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(CmsMarketingBundleHorizontalMerchCard);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/CmsMarketingBundleHorizontalMerchCard.js
// module id = 847
// module chunks = 5 6